import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'option', 'Option', [["path",{"d":"M14 6h5m0 12h-5l-5 -12h-4","key":"svg-0"}]]);